import type { CandidateTab } from '@/pages/Candidate/hooks/useCandidateTabs/types';

export const isEnabled = (flag: string | undefined) => flag === undefined || flag === 'true';

/** Emergency override: ignore tab_availability from API and show every env-enabled tab. */
export const isShowAllTabsOverride = () => import.meta.env.VITE_CANDIDATE_SHOW_ALL_TABS === 'true';

/** Parse comma-separated tab keys from VITE_CANDIDATE_FORCE_TABS. */
export const parseForcedTabs = (
  raw: string | undefined,
  validTabs: readonly CandidateTab[]
): ReadonlySet<CandidateTab> => {
  if (!raw?.trim()) return new Set();

  const valid = new Set(validTabs);
  return new Set(
    raw
      .split(',')
      .map((tab) => tab.trim())
      .filter((tab): tab is CandidateTab => valid.has(tab as CandidateTab))
  );
};

export const getForcedTabs = (validTabs: readonly CandidateTab[]): ReadonlySet<CandidateTab> =>
  parseForcedTabs(import.meta.env.VITE_CANDIDATE_FORCE_TABS, validTabs);

export const isTabForceVisible = (tab: CandidateTab, validTabs: readonly CandidateTab[]): boolean =>
  isShowAllTabsOverride() || getForcedTabs(validTabs).has(tab);
